import { FormControl, styled } from '@mui/material';
import { CustomTextField } from 'components';

const elementWidth = '100%';


export const StyledCustomTextField = styled(CustomTextField)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
}));